var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color-preview"},[_c('div',{staticClass:"thick-border well",style:({'background-color': `#${_vm.color}`}),on:{"click":function($event){return _vm.$emit('click')}}}),_c('h2',[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }